import React from "react";
import moment from "moment";
import {utils} from "../services/utils";
import {BaseComponent} from "../components/basecomponent";


// Company details shown in the agreement header and footer.
// NOTE: confirm the company email address before printing.
const COMPANY = {
    name: "Twenties Capital (Private) Limited",
    address: [
        "Shop 5, Ground Floor, Eastgate Mall",
        "Cnr Sam Nujoma Street & Speke Avenue, Harare",
    ],
    tel: "+263 242 707 021",
    whatsapp: "+263 712 281 508",
    mobile: ["+263 774 189 315", "+263 773 243 156"],
    email: "",
    footer: "Twenties Capital (Private) Limited is a licensed credit-only microfinance institution, registered as a microfinance institution in terms of the Microfinance Act [Chapter 24:30] and regulated by the Reserve Bank of Zimbabwe. Registration No. [__________]. Terms version 1.0 (October 2026).",
};


export class Agreement extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            loan: null,
            installments: []
        }
    }

    loanId = this.props.match.params.loanId;
    urls = {
        loans: "/loans",
        installments: "/installments/loan/"+this.loanId
    };

    componentDidMount() {
        this.getLoan();
        this.getInstallments();
    }

    getLoan(){
        this.get(this.urls.loans+'/'+this.loanId)
            .then(data => {
                utils.logger(data);
                this.setState({ loan: data.body });
            });
    }

    getInstallments(){
        this.get(this.urls.installments)
            .then(data => {
                utils.logger(data);
                this.setState({ installments: data.body.content });
            });
    }

    money = (n) => {
        if (n === null || n === undefined || n === "" || isNaN(n)) return "";
        return Number(n).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    };

    fmtDate = (d) => {
        if (!d) return "";
        return moment(d).format("DD/MM/YYYY");
    };

    render() {
        const loan = this.state.loan;
        const customer = loan ? (loan.customer || {}) : {};
        const installments = this.state.installments || [];

        const fullName = [customer.firstName, customer.lastName].filter(Boolean).join(" ");
        const term = loan ? (loan.tenure || loan.numberOfRepayments) : "";
        const instalment = installments[0]
            ? installments[0].total
            : (loan && term ? Math.ceil(loan.totalRepayment / term) : "");
        const refNumber = loan ? (loan.refNumber || loan.reference || loan.id) : "";
        const disbursementAccount = [customer.bank && customer.bank.name, customer.bankBranch, customer.bankAccountNumber]
            .filter(Boolean).join(" / ");
        const incomePct = (customer.netMonthlySalary && instalment)
            ? Math.round((Number(instalment) / Number(customer.netMonthlySalary)) * 100) + "%"
            : "";

        return (
            <div className="container mb-5" style={{maxWidth: 900, fontSize: 11}}>
                <div className="text-center">
                    <img src={process.env.PUBLIC_URL+"/static/img/twenties-logo.png"} alt="" style={{height: 70}}/>
                </div>
                { loan &&
                <div>
                    <div className="text-center mt-2">
                        <div style={{fontSize: 10, letterSpacing: 1, fontWeight: "bold"}}>LICENSED CREDIT-ONLY MICROFINANCE INSTITUTION</div>
                        <div style={{fontSize: 16, fontWeight: "bold"}}>LOAN AGREEMENT</div>
                        <div className="d-flex justify-content-between">
                            <span>No. {refNumber}</span>
                            <span>Date: {this.fmtDate(loan.loanDate)}</span>
                        </div>
                    </div>

                    <div className="text-center" style={{fontSize: 10, lineHeight: 1.4}}>
                        <div><strong>{COMPANY.name}</strong></div>
                        <div>{COMPANY.address[0]}</div>
                        <div>{COMPANY.address[1]}</div>
                        <div>Tel {COMPANY.tel} | WhatsApp {COMPANY.whatsapp}</div>
                        <div>Mobile {COMPANY.mobile[0]} | {COMPANY.mobile[1]}</div>
                        <div>Email: {COMPANY.email}</div>
                    </div>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>A. BORROWER DETAILS</h6>
                    <table className="table table-bordered table-sm mb-0 w-100">
                        <tbody>
                            <tr>
                                <td style={{width: "18%"}}>Full names &amp; surname</td>
                                <td style={{width: "32%"}}>{fullName}</td>
                                <td style={{width: "18%"}}>ID / passport no.</td>
                                <td style={{width: "32%"}}>{customer.idNumber}</td>
                            </tr>
                            <tr>
                                <td>Residential address</td>
                                <td>{customer.address}</td>
                                <td>Mobile / WhatsApp</td>
                                <td>{customer.mobilePhone}</td>
                            </tr>
                            <tr>
                                <td>Employer / business</td>
                                <td>{customer.typeOfBusiness}</td>
                                <td>EC no. &amp; work address</td>
                                <td>{customer.pensionNumber}</td>
                            </tr>
                            <tr>
                                <td>Net monthly income</td>
                                <td>US$ {this.money(customer.netMonthlySalary)} per payslip / statement</td>
                                <td>Other loans (instalment)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Disbursement account</td>
                                <td>{disbursementAccount}</td>
                                <td>Next of kin &amp; phone</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>B. COST OF CREDIT SUMMARY &ndash; read this before you sign</h6>
                    <table className="table table-bordered table-sm mb-0 w-100">
                        <tbody>
                            <tr>
                                <td style={{width: "18%"}}>Loan amount</td>
                                <td style={{width: "32%"}}>US$ {this.money(loan.principal)}</td>
                                <td style={{width: "18%"}}>Term</td>
                                <td style={{width: "32%"}}>{term} months &ndash; {loan.numberOfRepayments} monthly instalments</td>
                            </tr>
                            <tr>
                                <td>Interest rate</td>
                                <td>{loan.interestRate}% per month on the loan amount for the term</td>
                                <td>Total interest</td>
                                <td>US$ {this.money(loan.interest)}</td>
                            </tr>
                            <tr>
                                <td>Total you will repay</td>
                                <td>US$ {this.money(loan.totalRepayment)}</td>
                                <td>Monthly instalment</td>
                                <td>US$ {this.money(instalment)}</td>
                            </tr>
                            <tr>
                                <td>First instalment date</td>
                                <td>{this.fmtDate(loan.firstPaymentDate)}</td>
                                <td>Last instalment date</td>
                                <td>{this.fmtDate(loan.lastPaymentDate)}</td>
                            </tr>
                            <tr>
                                <td colSpan="4">Fees &amp; charges: none &ndash; interest is the only cost. Early settlement: allowed any time, no fee. Late payment: interest at 10% per month on the overdue amount, no separate penalty; collection costs only on proof; total after arrears never exceeds the balance owing when arrears began.</td>
                            </tr>
                        </tbody>
                    </table>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>C. REPAYMENT SCHEDULE</h6>
                    { installments.length > 0 &&
                    <div style={{overflowX: "auto"}}>
                        <table className="table table-bordered table-sm mb-0 w-100" style={{fontSize: 9}}>
                            <tbody>
                                <tr>
                                    <td style={{fontWeight: "bold", whiteSpace: "nowrap"}}>Instalment</td>
                                    { installments.map((v, i) => <td key={i}>{i+1}</td>) }
                                </tr>
                                <tr>
                                    <td style={{fontWeight: "bold", whiteSpace: "nowrap"}}>Due date</td>
                                    { installments.map((v, i) => <td key={i}>{this.fmtDate(v.date)}</td>) }
                                </tr>
                                <tr>
                                    <td style={{fontWeight: "bold", whiteSpace: "nowrap"}}>Amount US$</td>
                                    { installments.map((v, i) => <td key={i}>{this.money(v.total)}</td>) }
                                </tr>
                            </tbody>
                        </table>
                    </div> }
                    <div style={{fontSize: 9, fontStyle: "italic"}}>One column per instalment for the term. Instalment = (loan amount + total interest) &divide; months; last instalment adjusted for rounding.</div>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>D. TERMS AND CONDITIONS <span style={{fontWeight: "normal"}}>(&ldquo;you&rdquo; = the Borrower in Part A; &ldquo;we&rdquo; / &ldquo;us&rdquo; = Twenties Capital (Private) Limited)</span></h6>
                    <div style={{fontSize: 9, lineHeight: 1.4}}>
                        <div><strong>1. Loan.</strong> We lend you the amount in Part B on these terms, paid in cash at our office or into the account in Part A. You confirm receipt by signing in Part E. Parts A to F are the whole agreement.</div>
                        <div><strong>2. Interest and cost.</strong> Interest is 10% per month on the loan amount for the term, as shown in Part B. There is no application, processing, administration or insurance fee: interest is the only cost and does not exceed the 10% per month maximum set by the Reserve Bank of Zimbabwe for microfinance institutions.</div>
                        <div><strong>3. Repayment.</strong> Pay the instalments on the dates in Part C by stop order, salary deduction (where your employer signs in Part E), cash, mobile money or bank transfer. A stop order or payroll authority covers only the amounts in Parts B and C and clause 5, and ends when the loan is repaid. Payments go first to overdue interest, then to the loan amount.</div>
                        <div><strong>4. Paying early.</strong> You may repay in full or in part at any time, paying only the balance of the loan amount plus interest for the months that have passed; interest for the remaining months falls away. No fee or penalty is charged.</div>
                        <div><strong>5. Paying late.</strong> Interest continues at 10% per month on any overdue amount; there is no separate penalty. If you are more than 30 days in arrears we may, on 7 days&rsquo; written notice (letter, SMS or WhatsApp), require the whole balance. We may recover reasonable collection costs actually incurred (tracing, legal costs on the ordinary court scale) on proof. Interest and costs charged after you fall into arrears will never exceed the balance owing when the arrears began. Late payment and default are reported to the RBZ Credit Registry and licensed credit bureaus.</div>
                        <div><strong>6. Your information.</strong> Part A is true and complete, including your income and all other loans. You agree that we may verify it with your employer, bank and other lenders, obtain credit reports from the Credit Registry and licensed credit bureaus, and report this loan to them as the law requires. We keep your information confidential and use it only for this loan and as the law requires. Tell us within 7 days of any change of employer, address, phone or bank account.</div>
                        <div><strong>7. Changes and transfer.</strong> No change is valid unless in writing signed by both of us; we will not change the interest, instalments or your obligations on our own. We may transfer our rights only on written notice, without changing your rights or obligations.</div>
                        <div><strong>8. Statements.</strong> A statement of the amount lent, payments, interest, costs and balance is available free on request.</div>
                        <div><strong>9. Complaints.</strong> Contact our Customer Service Officer at the address above, +263 242 707 021 / +263 712 281 508 (WhatsApp) or {COMPANY.email}. Complaints are free; we acknowledge within 48 hours and answer in writing within 10 working days. If not satisfied you may refer the matter to the Reserve Bank of Zimbabwe, 80 Samora Machel Avenue, P.O. Box 1283, Harare.</div>
                        <div><strong>10. Time to consider; withdrawal.</strong> You received this agreement with Parts B and C on the date in Part F and had at least 24 hours to consider it before signing. You may withdraw before the loan is paid to you, in writing or by WhatsApp, at no cost.</div>
                        <div><strong>11. Law and notices.</strong> Zimbabwean law applies. Your residential address in Part A is your address for notices and court process, and the courts of Zimbabwe may decide any dispute. Nothing here removes your rights under the Microfinance Act [Chapter 24:30] or the RBZ Consumer Protection Framework.</div>
                    </div>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>E. BORROWER&rsquo;S DECLARATION, SIGNATURES AND PAYROLL DEDUCTION AUTHORITY</h6>
                    <div style={{fontSize: 9, lineHeight: 1.4}}>
                        <span>&#9744;</span> I had the chance to read this agreement and it was explained to me in English / Shona / Ndebele, a language I understand.&nbsp;
                        <span>&#9744;</span> I understand the interest, instalments, total repayable and what happens if I pay late.&nbsp;
                        <span>&#9744;</span> Part A is true and I have declared all my other loans.&nbsp;
                        <span>&#9744;</span> I have received a signed copy.&nbsp;
                        Payroll deduction: where instalments are collected through my employer, my signature below authorises my employer to deduct the instalments in Part C from my salary and pay them to Twenties Capital (Private) Limited until the loan is repaid; the employer&rsquo;s stamp confirms this.
                    </div>
                    <div className="row mt-2">
                        <div className="col-6">
                            <div style={{borderBottom: "1px solid #000", height: 40}}></div>
                            <div style={{fontWeight: "bold"}}>Borrower &ndash; signature or right thumbprint</div>
                            <div>Name: {fullName}</div>
                            <div>Date:</div>
                        </div>
                        <div className="col-6">
                            <div style={{borderBottom: "1px solid #000", height: 40}}></div>
                            <div style={{fontWeight: "bold"}}>Witness &ndash; Loan Officer</div>
                            <div>Name:</div>
                            <div>Date:</div>
                        </div>
                        <div className="col-6 mt-3">
                            <div style={{borderBottom: "1px solid #000", height: 40}}></div>
                            <div style={{fontWeight: "bold"}}>For Twenties Capital (Private) Limited</div>
                            <div>Name / position:</div>
                            <div>Date:</div>
                        </div>
                        <div className="col-6 mt-3">
                            <div style={{borderBottom: "1px solid #000", height: 40}}></div>
                            <div style={{fontWeight: "bold"}}>Employer &ndash; stamp &amp; signature (payroll deduction)</div>
                            <div>Name / position:</div>
                            <div>Date:</div>
                        </div>
                    </div>

                    <h6 className="mt-3 mb-1" style={{fontWeight: "bold"}}>F. OFFICE USE</h6>
                    <table className="table table-bordered table-sm mb-0 w-100">
                        <tbody>
                            <tr>
                                <td style={{width: "18%"}}>Quotation given to client</td>
                                <td style={{width: "32%"}}></td>
                                <td style={{width: "18%"}}>Instalment % of net income</td>
                                <td style={{width: "32%"}}>{incomePct} limit Y / N</td>
                            </tr>
                            <tr>
                                <td>Credit Registry / bureau</td>
                                <td>clear / adverse</td>
                                <td>Approved by</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Disbursed</td>
                                <td></td>
                                <td>Copy given to client</td>
                                <td><span>&#9744;</span> Yes</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="mt-3 pt-2" style={{borderTop: "1px solid #000", fontSize: 8}}>
                        {COMPANY.footer}
                    </div>
                </div>
                }
            </div>
        );
    }
}
